import { ChartAxis, ChartSerie } from "./common-chart";

export class StackedChartDatasource {
  zoomInfo: any;
  title: string;
  series: ChartSerie[];
  axisX: ChartAxis;
  axisY: ChartAxis;
  xValues: number[];
  xLabels: string[];
}
